// extracted by mini-css-extract-plugin
export default {"card":"Card_card__oso-+","placeholder":"Card_placeholder__CUu3y","placeholder_small":"Card_placeholder_small__jFtQd"};